'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { BaseButton } from '@7f-ui/components/button/button';
import { CardSlider, CardSliderList, CardSliderListItem, CardSliderNavButtons } from '@7f-ui/components/card-slider/card-slider';
import { Price } from '@7f-ui/components/price';
import { CaretRight } from '@phosphor-icons/react';
import { formatDate, formatDateWithWeekday } from '@utils/utils-format';
import { useRef } from 'react';
import type { ExperienceDayPrices } from '../_hooks/use-app-experience-day-prices';
import type { PurchasableDay } from '../_hooks/use-app-experience-purchasable-days';
import { TICKET_DAYS_PREVIEW_COUNT } from '../_hooks/use-app-experience-purchasable-days';
import { cheapestDayPrice } from '../_lib/day-prices';
import { useExperienceFilterContext } from './app-experience-filter-provider';
type AppExperienceTicketDaysProps = {
  days: PurchasableDay[];
  basePrice?: number | null;
  currency: string;
  pricesByDate?: ExperienceDayPrices;
  selectedDate?: string | null;
  onSelectDay: (day: PurchasableDay) => void;
  onShowAll: () => void;
};
export function AppExperienceTicketDays(t0) {
  const $ = _c(48);
  const {
    days,
    basePrice,
    currency,
    pricesByDate,
    selectedDate,
    onSelectDay,
    onShowAll
  } = t0;
  const cardSliderListRef = useRef(null);
  let T0;
  let T1;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== basePrice || $[1] !== currency || $[2] !== days || $[3] !== onSelectDay || $[4] !== pricesByDate || $[5] !== selectedDate) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const previewDays = days.slice(0, TICKET_DAYS_PREVIEW_COUNT);
      if (previewDays.length === 0) {
        t10 = null;
        break bb0;
      }
      t8 = "py-8";
      t9 = "TicketDays.section";
      t7 = "bleed-container";
      T1 = CardSlider;
      t5 = true;
      let t11;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = <h2 className="font-heading2">Eintrittskarten</h2>;
        $[18] = t11;
      } else {
        t11 = $[18];
      }
      t6 = <div className="flex items-center justify-between">{t11}<CardSliderNavButtons sliderListRef={cardSliderListRef} amountOfItems={previewDays.length} ariaLabelPrevious="Vorheriger Termin" ariaLabelNext={"N\xE4chster Termin"} /></div>;
      T0 = CardSliderList;
      t1 = "-mr-4 xs:-mr-6 w-full pr-1 sm:mr-0";
      t2 = cardSliderListRef;
      t3 = true;
      let t12;
      if ($[19] !== basePrice || $[20] !== currency || $[21] !== onSelectDay || $[22] !== pricesByDate || $[23] !== selectedDate) {
        t12 = day => <CardSliderListItem key={day.date} className="relative grid-cols-3"><TicketDayItem day={day} basePrice={cheapestDayPrice(pricesByDate?.get(day.date)) ?? basePrice} currency={currency} isSelected={day.date === selectedDate} onClick={onSelectDay} /></CardSliderListItem>;
        $[19] = basePrice;
        $[20] = currency;
        $[21] = onSelectDay;
        $[22] = pricesByDate;
        $[23] = selectedDate;
        $[24] = t12;
      } else {
        t12 = $[24];
      }
      t4 = previewDays.map(t12);
    }
    $[0] = basePrice;
    $[1] = currency;
    $[2] = days;
    $[3] = onSelectDay;
    $[4] = pricesByDate;
    $[5] = selectedDate;
    $[6] = T0;
    $[7] = T1;
    $[8] = t1;
    $[9] = t10;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[6];
    T1 = $[7];
    t1 = $[8];
    t10 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="font-body-small font-semibold">Alle Termine anzeigen</span>;
    t12 = <CaretRight height={16} width={16} />;
    $[25] = t11;
    $[26] = t12;
  } else {
    t11 = $[25];
    t12 = $[26];
  }
  let t13;
  if ($[27] !== onShowAll) {
    t13 = <CardSliderListItem className="relative grid-cols-3"><BaseButton className="flex h-full items-center gap-2 rounded-2xl border border-primary-green/15 bg-white p-6 font-body-copy hover:bg-hover-light active:bg-active-light" onClick={onShowAll} data-testid="TicketDays.showAll">{t11}{t12}</BaseButton></CardSliderListItem>;
    $[27] = onShowAll;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== T0 || $[30] !== t1 || $[31] !== t13 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4) {
    t14 = <T0 className={t1} ref={t2} isSlidable={t3}>{t4}{t13}</T0>;
    $[29] = T0;
    $[30] = t1;
    $[31] = t13;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== T1 || $[37] !== t14 || $[38] !== t5 || $[39] !== t6) {
    t15 = <T1 fullBleed={t5}>{t6}{t14}</T1>;
    $[36] = T1;
    $[37] = t14;
    $[38] = t5;
    $[39] = t6;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t15 || $[42] !== t7) {
    t16 = <div className={t7}>{t15}</div>;
    $[41] = t15;
    $[42] = t7;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t16 || $[45] !== t8 || $[46] !== t9) {
    t17 = <section className={t8} data-testid={t9}>{t16}</section>;
    $[44] = t16;
    $[45] = t8;
    $[46] = t9;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  return t17;
}
type TicketDayItemProps = {
  day: PurchasableDay;
  basePrice?: number | null;
  currency: string;
  isSelected: boolean;
  onClick: (day: PurchasableDay) => void;
};
function TicketDayItem(t0) {
  const $ = _c(21);
  const {
    day,
    basePrice,
    currency,
    isSelected,
    onClick
  } = t0;
  const {
    ticketCalendar
  } = useExperienceFilterContext();
  const date = day.date;
  let t1;
  if ($[0] !== day || $[1] !== onClick) {
    t1 = () => onClick(day);
    $[0] = day;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `TicketDays.day.${day.date}`;
  const t3 = isSelected ? "border-2 border-primary" : "border border-primary-green/15";
  let t4;
  if ($[3] !== t3) {
    t4 = cx("flex w-58 flex-col items-start gap-2 rounded-2xl bg-white p-4 text-left font-body-copy hover:bg-hover-light active:bg-active-light", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== date || $[6] !== day.date || $[7] !== ticketCalendar.today) {
    t5 = day.date === ticketCalendar.today ? `Heute, ${formatDate(date)}` : formatDateWithWeekday(date);
    $[5] = date;
    $[6] = day.date;
    $[7] = ticketCalendar.today;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <p className="font-body-copy font-semibold">{t5}</p>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== basePrice || $[12] !== currency) {
    t7 = typeof basePrice === "number" && <p className="font-body-small text-secondary-text">{"ab "}<Price className="font-body-copy font-semibold" amount={basePrice} currency={currency} />{" inkl. MwSt."}</p>;
    $[11] = basePrice;
    $[12] = currency;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isSelected || $[15] !== t1 || $[16] !== t2 || $[17] !== t4 || $[18] !== t6 || $[19] !== t7) {
    t8 = <BaseButton onClick={t1} data-testid={t2} aria-pressed={isSelected} className={t4}>{t6}{t7}</BaseButton>;
    $[14] = isSelected;
    $[15] = t1;
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}